import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import atatus from 'atatus';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import { tagForm } from 'tagManager';

import scrollTo from '../../utils/scrollTo';
import ErrorView from '../errors/ErrorView';
import registrationErrors from '../errors/registrationErrors';
import PasswordConfirmation from '../inputs/PasswordConfirmation';
import OverlaySpinner from '../spinner/OverlaySpinner';
import { PrimaryButtonSto, TextInputSto } from '../sto';

import TermsAndCondition from './TermsAndCondition';

function SignUpForm(props) {
    const intl = useIntl();
    const [form, setForm] = useState({
        passwordState: false,
        passwordValue: '',
        username: '',
        usernameStateValid: null,
    });
    const [isFormValid, setFormValidity] = useState(false);
    const [error, setError] = useState(null);
    const [isRegisteringUser, setIsRegisteringUser] = useState(false);

    useEffect(() => {
        setFormValidity(form.usernameStateValid && form.passwordState === true);
    }, [form]);

    const handleInputChange = (event) => {
        const fieldName = event.target.name;
        const value = event.target.value.replace(/[^\w@_.]/g, '');
        const newForm = Object.assign({}, form);
        newForm[fieldName] = value;
        newForm.usernameStateValid =
            value.length >= 3 ? true : value.length < 3 && newForm.usernameStateValid !== null ? false : null;
        setForm(newForm);
    };

    const onPasswordChange = (password) => {
        const newForm = Object.assign({}, form);
        newForm.passwordValue = password.passwordValue;
        newForm.passwordState = password.passwordState;
        setForm(newForm);
    };
    const handleSubmitClick = async (e) => {
        e.preventDefault();
        scrollTo(0, 0);
        setError(null);

        if (!isFormValid) {
            return;
        }

        const { passwordValue: password, username } = form;
        const { verificationkey } = props;
        const { locale } = intl;

        const signUpParams = {
            attributes: {
                'custom:verification_key': verificationkey,
                email: props.email,
                locale,
            },
            password,
            username,
        };
        setIsRegisteringUser(true);
        atatus.startTransaction('Registration-Step-2-User-Creation');
        try {
            const res = await Auth.signUp(signUpParams);
            const { user } = res;
            atatus.endTransaction('Registration-Step-2-User-Creation');
            tagForm({
                fields: { username: username },
                name: 'registration-step-2',
                success: true,
            });
            props.onSubmit(user.username, res.codeDeliveryDetails.Destination);
        } catch (e) {
            setIsRegisteringUser(false);
            const errorMessage = registrationErrors[e.code];
            setError(errorMessage || 'general.unexpectedErrorOccurred');
            atatus.failTransaction('Registration-Step-2-User-Creation');
            tagForm({
                fields: { username: username },
                message: e.message,
                name: 'registration-step-2',
                success: false,
            });
        }
    };

    return (
        <div>
            <ErrorView error={error} />
            {isRegisteringUser && <OverlaySpinner />}
            <form onSubmit={handleSubmitClick}>
                <TextInputSto
                    errorMessage="pages.login.username.field.error"
                    isValid={form.usernameStateValid}
                    label="pages.registration.step2.username.field"
                    name="username"
                    onChange={handleInputChange}
                    placeholder="pages.login.username.placeholder"
                    value={form.username}
                />
                <PasswordConfirmation
                    onChange={onPasswordChange}
                    password={{
                        passwordState: form.passwordState,
                        passwordValue: form.passwordValue,
                    }}
                />
                <TermsAndCondition />
                <PrimaryButtonSto disabled={!isFormValid} labelKey="pages.button.continue" type="submit" />
            </form>
        </div>
    );
}

SignUpForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    verificationkey: PropTypes.string.isRequired,
};

export default SignUpForm;
